export default __webpack_public_path__ + "static/media/lockers-2.7338287f.svg";